import React,{useState} from "react"
import { Link } from "react-router-dom";

import { portfolioData, portfolioImg } from "../data/portfolio"

import Lightbox from 'react-18-image-lightbox';
import "react-18-image-lightbox/style.css"

import {FiCamera} from '../assets/icons/vander'

export default function ClassicPortfolio({grid, col, row}) {
    let [isOpen, setisOpen] = useState(false);
    let [currentImageIndex, setCurrentImageIndex] = useState(0);
    let [selectedCategory, setSelectedCategory] = useState(null);

    let handleMovePrev = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + portfolioImg.length - 1) % portfolioImg.length);
    };
  
    let handleMoveNext = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % portfolioImg.length);
    };
    let handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setisOpen(true);
    };
    let currentImage = portfolioImg[currentImageIndex-1];
  
    let matchCategory = (category) => {
        setSelectedCategory(category);
    };
  
    let filteredData = selectedCategory
    ? portfolioData.filter((item) => item.category === selectedCategory)
    : portfolioData;

  return (
    <>
        <div className="row justify-content-center">
            <div className="col-12">
                <div className="filters-group-wrap text-center">
                    <div className="filters-group">
                        <ul className="container-filter mb-0 categories-filter list-unstyled filter-options">
                            <li className={`list-inline-item categories position-relative ${selectedCategory === null ? 'active' : ''}`} onClick={()=>matchCategory(null)}>All</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'branding' ? 'active' : ''}`} onClick={()=>matchCategory('branding')}>Branding</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'designing' ? 'active' : ''}`} onClick={()=>matchCategory('designing')} >Designing</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'photography' ? 'active' : ''}`} onClick={()=>matchCategory('photography')}>Photography</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'development' ? 'active' : ''}`} onClick={()=>matchCategory('development')}>Development</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className="row justify-content-center">
            <div className={grid}>
                <div id="grid" className={row}>
                    {filteredData.map((item,index)=>{
                        return(
                            <div className={col} data-groups='["branding"]' key={index}>
                                <div className="card shadow border-0 portfolio portfolio-classic portfolio-primary rounded overflow-hidden">
                                    <div className="card-img position-relative">
                                        <img src={item.image} className="img-fluid" alt=""/>
                                        <div className="card-overlay"></div>

                                        <div className="pop-icon">
                                            <Link to="#" onClick={()=>handleImageClick(item.id)} className="btn btn-pills btn-icon lightbox"><i><FiCamera/></i></Link>
                                        </div>
                                    </div>
                                    <div className="content text-center p-3">
                                        <Link to={`/portfolio-detail-one/${item.id}`} className="text-dark h6 mb-0 d-block title">{item.title}</Link>
                                        <small className="text-muted fw-normal mb-0">{item.name}</small>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div> 

        {isOpen && (
            <Lightbox
                mainSrc={currentImage}
                prevSrc={portfolioImg[(currentImageIndex + portfolioImg.length - 1) % portfolioImg.length]}
                nextSrc={portfolioImg[(currentImageIndex + 1) % portfolioImg.length]}

                onCloseRequest={() => setisOpen(false)}
                onMovePrevRequest={handleMovePrev}
                onMoveNextRequest={handleMoveNext}
            />
        )}
    </>
  )
}
